import React from "react";
import { Layout } from "components/Layout/Layout";
import { CustomReports } from "./CustomReports";

export const CustomReportsIndex = () => {
  return (
    <Layout>
      <CustomReports />
    </Layout>
  );
};
